<template>
  <div class="w-100 confirmation-page">
    <!-- START Navigation and related information -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <interview-navi :navData="navData"></interview-navi>
    </div>
    <div role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}">
      <div class="row">
        <!-- Home Confirmation START -->
        <div class="col-6 pr-2">
          <div v-if="showHomeForceBindMsg">
            <bundle-confirmation-reminder :carrierType="carrierType" :errorMessage="homeForceBindMsg"></bundle-confirmation-reminder>
          </div>
          <home-confirmation v-else-if="getHomeCarrier"></home-confirmation>
          <div v-else-if="isHomeEzlynx">
            <bundle-confirmation-reminder :carrierType="carrierType"></bundle-confirmation-reminder>
          </div>
        </div>
        <!-- Home Confirmation END -->
        <!-- AUTO Confirmation START -->
        <div class="col-6 pl-2">
          <div v-if="getAutoCarrier && showAutoForceBindMsg">
            <bundle-confirmation-reminder :carrierType="'Auto'" :errorMessage="autoForceBindMsg"></bundle-confirmation-reminder>
          </div>
          <auto-confirmation v-else-if="getAutoCarrier"></auto-confirmation>
          <div v-else-if="isAutoEzlynx">
            <bundle-confirmation-reminder :carrierType="'Auto'"></bundle-confirmation-reminder>
          </div>
        </div>
        <!-- AUTO Confirmation END -->
      </div>
  </div>
  <!-- Bound Policy Alert -->
  <!-- <form-alerts v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'" :pageData="policyBindError" class="policy-bound-alert"></form-alerts> -->
  </div>
</template>

<script>
// TODO: Remove eslint
/* eslint-disable */
import InterviewNavigation from './Navigation';
import InterviewNavigationTitle from './NavigationTitle';
// import fetchData from '../../../services/fetchData';
// import common from '../../../services/common';
import { pageMixin } from '../../../mixins/pageMixin';
import AutoConfirmation from './AutoConfirmation';
import BundleConfirmationReminder from './BundleConfirmationReminder';
import HomeConfirmation from './HomeConfirmation';

export default {
  mixins: [pageMixin],
  data() {
    return {
      flowType: '',
      pageData: {},
      homePageData: {},
      autoForceBindMsg : {
        forceBind: true,
        msg: '<strong>Policy Bound:</strong> This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.',
        showCarrierLogo: true,
        // logoPathSvg: 'https://dev.insurance.com/insurance/media/carrier/ucp/svgLogos/prog_ucp_logo.svg'
      },
      homeForceBindMsg : {
        forceBind: true,
        msg: '<strong>Policy Bound:</strong> This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.',
        showCarrierLogo: true,
        // logoPathSvg: 'https://dev.insurance.com/insurance/media/carrier/ucp/svgLogos/prog_ucp_logo.svg'
      },
    };
  },
  components: {
    AutoConfirmation,
    HomeConfirmation,
    // FormAlerts,
    interviewNavi: InterviewNavigation,
    interviewNaviTitle: InterviewNavigationTitle,
    BundleConfirmationReminder,
  },
  computed: {
    showAutoForceBindMsg() {
      this.autoForceBindMsg.logoPathSvg = this.getAutoCarrier ? this.getAutoCarrier.logoPathSvg : '';
      let autoBindDetails = sessionStorage.getItem('autoBindDetails') ? JSON.parse(sessionStorage.getItem('autoBindDetails')) : {};
      return sessionStorage.getItem('autobound') == 'true' && (autoBindDetails && autoBindDetails.quote_bind_type === 'Forced');
    },
    showHomeForceBindMsg() {
      this.homeForceBindMsg.logoPathSvg = this.getHomeCarrier ? this.getHomeCarrier.logoPathSvg : '';
      let homeBindDetails = sessionStorage.getItem('homeBindDetails') ? JSON.parse(sessionStorage.getItem('homeBindDetails')) : {};
      return sessionStorage.getItem('homebound') == 'true' && (homeBindDetails && homeBindDetails.quote_bind_type === 'Forced');
    },
    carrierType() {
      this.flowType = sessionStorage.getItem('flowType');
      return this.flowType === 'bundle' ? 'Home' :this.flowType === 'cabundle' ? 'Condo' : 'Renters';
    },
    isHomeEzlynx() {
      return sessionStorage.getItem('selectedCarrierHome') != null  && JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type === 'EZLYNXCARRIER' || sessionStorage.getItem('homePdfLinkCov') != null;
    },
    isAutoEzlynx() {
      return sessionStorage.getItem('selectedCarrierAuto') != null  && JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type === 'EZLYNXCARRIER'  || sessionStorage.getItem('pdfLinkCov') != null;
    },
    getHomeCarrier() {
      return sessionStorage.getItem('selectedCarrierHome') != null  && JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type !== 'EZLYNXCARRIER' && sessionStorage.getItem('homePdfLinkCov') == null ? JSON.parse(sessionStorage.getItem('selectedCarrierHome')) : false;
    },
    getAutoCarrier() {
      return sessionStorage.getItem('selectedCarrierAuto') != null && JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type !== 'EZLYNXCARRIER' && sessionStorage.getItem('pdfLinkCov') == null ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')) : false;    
    }, 
    navData() {
      if (this.getAutoCarrier) {
        return this.pageData;
      } else {
        return this.homePageData;
      }
    },
  },
  methods: {   
    handlePageData(pageData) {
      this.pageData = pageData;
    },
    handleHomePageData(pageData) {
      this.homePageData = pageData;
    },
  },
  mounted() {
    this.$root.$on("pageDataUpdate", this.handlePageData);
    this.$root.$on("homePageDataUpdate", this.handleHomePageData);
  },
  watch: {
    'pageData': function fieldValue(newValue) {      
    },
    'homePageData': function fieldValue(newValue) {      
    },
  },
};
</script>
<style>
  .quote-panel-open, .quote-panel-close {
    margin-top: 10.5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/BundleConfirmation.vue?37beed9b